import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';
import { ToastContextConsumer } from '../Toast/ToastContext';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Caught by ErrorBoundary:", error, info);
    Sentry.captureException(error, { extra: { componentStack: info?.componentStack } });

    if (this.props.addToast) {
      this.props.addToast("Something went wrong. Please try again.", false);
    }
  }

  render() {
    if (this.state.hasError) {
      // Just render nothing — toast will be shown
      return null;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  addToast: PropTypes.func, // received via consumer
};

// Wrap ErrorBoundary in context consumer
const ErrorBoundaryWithToast = (props) => (
  <ToastContextConsumer>
    {({ addToast }) => <ErrorBoundary {...props} addToast={addToast} />}
  </ToastContextConsumer>
);

export default ErrorBoundaryWithToast;
